import { debounce, throttle} from 'lodash'
import { computed } from 'vue'
import { ActionTypes, MutationTypes, useStore } from '@/store'
import stomp from '@/stomp/index'
import router from '@/router'
export default () => {
  const store = useStore()
  const { sendSaveState} = stomp()
  const slideIndex = computed(() => store.state.slideIndex)
  const inviteToken = computed(() => store.state.inviteInfo.inviteToken)
  const handleElementId = computed(() => store.state.handleElementId)
  const editList = computed(() => store.state.editList);
  const createID = computed(() => store.state.createID)
  const save = debounce(function() {
    store.dispatch(ActionTypes.SAVE_SLIDE)
    if (editList.value && editList.value.length < 2) return;
    setTimeout(function(){
      sendSaveState(handleElementId.value, slideIndex.value,inviteToken.value)
    },300)
  }, 100, { leading:false, trailing: true })
  
  // 添加历史快照(历史记录)
  const addHistorySnapshot = debounce(function() {
    const activeId:any = router.currentRoute.value.query.code
    const newArr = JSON.parse(localStorage.open as never)
    // // 判断进来和出去的时间  是否一样  一样可以  否则弹窗提示
    if (createID.value[activeId] !== newArr[activeId]) {
      store.commit(MutationTypes.SET_OPENMORE_VALUE, true)
     }
    store.dispatch(ActionTypes.ADD_SNAPSHOT)
    store.commit(MutationTypes.SAVE_SPINNING, true)
    save()
  }, 300, { trailing: true })

  // 重做
  const redo = throttle(function() {
    store.dispatch(ActionTypes.RE_DO)
  }, 100, { leading: true, trailing: false })

  // 撤销
  const undo = throttle(function() {
    store.dispatch(ActionTypes.UN_DO)
  }, 100, { leading: true, trailing: false })

  return {
    addHistorySnapshot,
    save,
    redo,
    undo,
  }
}